import React from 'react';
import { Button, Tooltip } from 'antd';
import { useTitle } from '../../Title/containers/TitleDataStore';
import ReviewEditorAnchor from '../../Reviews/ReviewEditor/ReviewEditorAnchor';
import { useReviews } from '../../Reviews/containers/ReviewsDataStore';
import PropTypes from 'prop-types';
import { useUser } from '../../User/containers/UserDataStore';
import { useAccountOrMembershipRequiredModalContext } from '../../Anonymous/AccountOrMembershipRequiredModal/contexts/AccountOrMembershipRequiredModalContext';

ReviewTitle.propTypes = {
	sku: PropTypes.string,
};

export default function ReviewTitle({ sku }) {
	const { refreshReview } = useTitle();
	const { refresh } = useReviews();
	const { isAnonymous } = useUser();
	const { setIsVisible } = useAccountOrMembershipRequiredModalContext();

	const refreshReviewInfo = () => {
		refreshReview();
		refresh();
	};

	const renderReviewTitleButton = () => {
		return (
			<Tooltip title="Review Title">
				<Button shape="circle">
					<div className="icon-review-icon review-title" />
				</Button>
			</Tooltip>
		);
	};

	return isAnonymous() ? (
		<div onClick={() => setIsVisible(true)}>
			{renderReviewTitleButton()}
		</div>
	) : (
		<ReviewEditorAnchor sku={sku} onUpdate={refreshReviewInfo}>
			{renderReviewTitleButton()}
		</ReviewEditorAnchor>
	);
}
